import { useState } from "react";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { db } from "../firebase";

function TransferBuildForm({ car, profile, showToast, onSent }) {
  const [recipientUsername, setRecipientUsername] = useState("");
  const [transferMileage, setTransferMileage] = useState("");
  const [transferNote, setTransferNote] = useState("");

  const sendTransferRequest = async () => {
    const cleanUsername = recipientUsername.trim().toLowerCase();

    if (!cleanUsername) {
      showToast("Missing Username", "Enter the recipient username.", "warning");
      return;
    }

    if (cleanUsername === profile.username.toLowerCase()) {
      showToast("Invalid Transfer", "You cannot transfer a build to yourself.", "warning");
      return;
    }

    const profilesSnapshot = await getDocs(
      query(
        collection(db, "profiles"),
        where("usernameLowercase", "==", cleanUsername)
      )
    );

    if (profilesSnapshot.empty) {
      showToast(
        "User Not Found",
        "No user found with that username. They may need to log in and save their profile once first.",
        "error"
      );
      return;
    }

    const recipientProfile = profilesSnapshot.docs[0].data();

    const existingRequestSnapshot = await getDocs(
      query(
        collection(db, "transferRequests"),
        where("carId", "==", car.id),
        where("fromUserId", "==", profile.userId),
        where("toUserId", "==", recipientProfile.userId),
        where("status", "==", "pending")
      )
    );

    if (!existingRequestSnapshot.empty) {
      showToast(
        "Transfer Already Pending",
        "You already have a pending transfer request for this user.",
        "warning"
      );
      return;
    }

    await addDoc(collection(db, "transferRequests"), {
      carId: car.id,
      carName: car.name,
      fromUsername: profile.username,
      fromUserId: profile.userId,
      toUsername: recipientProfile.username,
      toUserId: recipientProfile.userId,
      mileage: transferMileage,
      note: transferNote,
      status: "pending",
      requestedAt: new Date().toISOString()
    });

    setRecipientUsername("");
    setTransferMileage("");
    setTransferNote("");

    if (onSent) onSent();

    showToast("Transfer Request Sent", "The build transfer request has been sent.");
  };

  return (
    <div style={formStyle}>
      <input
        placeholder="Recipient username"
        value={recipientUsername}
        onChange={(e) => setRecipientUsername(e.target.value)}
        style={inputStyle}
      />

      <input
        placeholder="Current mileage at transfer"
        value={transferMileage}
        onChange={(e) => setTransferMileage(e.target.value)}
        style={inputStyle}
      />

      <textarea
        placeholder="Transfer note — optional"
        value={transferNote}
        onChange={(e) => setTransferNote(e.target.value)}
        style={textareaStyle}
      />

      <button onClick={sendTransferRequest} style={transferButtonStyle}>
        Send Transfer Request
      </button>
    </div>
  );
}

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px"
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #333",
  backgroundColor: "#111",
  color: "white"
};

const textareaStyle = {
  ...inputStyle,
  minHeight: "80px",
  resize: "vertical"
};

const transferButtonStyle = {
  width: "100%",
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  padding: "12px",
  borderRadius: "10px",
  fontWeight: "bold",
  cursor: "pointer"
};

export default TransferBuildForm;